import {Card} from '../../components/ui/Card';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {H1} from '../../components/ui/Header';
import Flex from '../../components/ui/Flex';
import {FormButtons} from '../../components/ui/Form';
import Button from '../../components/ui/Button';
import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {cartUpdated, selectAllCart} from './cartSlice';

const CartList = styled.ul`
  list-style-type: none;
  //padding: 16px;
  padding: 0;
  margin: 0 auto;

  > li:not(:last-child) {
    margin-bottom: 20px;
  }
`

const CartItem = styled.li`
  display: flex;
  flex-wrap: wrap;

  justify-content: space-between;
  input[type=text] {

  }

`

const CartCard = styled(Card)`
  @media screen and (min-width: 600px) {
    flex: 1;
    min-width: 40vw;
    max-width: 800px;
  }
`

export default function Cart() {
  const dispatch = useDispatch()
  const cart = useSelector(selectAllCart)
  const [quantities, setQuantities] = useState([0])
  const [subtotal, setSubtotal] = useState(0)
  const history = useHistory()

  // Update item quantities and subtotals every time the cart changes
  useEffect(() => {
    let newSubtotal = 0
    let newQuantities = []
    for(let i = 0; i < cart.length; i++) {
      // Assume an amount of zero if a cart quantity is blank
      newSubtotal += cart[i].product.price * (cart[i].amount === '' ? 0 : cart[i].amount)
      newQuantities[i] = cart[i].amount
    }

    setQuantities(newQuantities)
    setSubtotal(newSubtotal.toFixed(2))
  }, [cart])

  // Handle updating cart quantities
  const handleChange = (i, value) => {

    if(value < 0) {
      value = 0
    }

    //const newProduct = { amount: value, product: cart[i].product}
    //updateCartByIndex(newProduct, i)
    dispatch(cartUpdated({ amount: value, id: cart[i].product.id}))
  }

  const handleCheckout = () => {
    history.push('/checkout')
  }

  return (
    <CartCard>
      <H1>
        Shopping Cart
      </H1>
      <CartList>
        { cart.length > 0 ? cart.map((p, i) =>
            <CartItem key={i}>
              <Flex>
                <img height={100} width={100} style={{objectFit: 'cover'}} src={p.product.image} alt={p.product.name}/>
                <div style={{paddingLeft: '1em'}}>
                  <p>{p.product.name}: ${p.product.price}</p>
                  <input type='number' style={{width: '3em'}} size={1} value={quantities[i]} onChange={event => handleChange(i, event.target.value)}/>
                </div>
              </Flex>
             <p>${(p.product.price * p.amount).toFixed(2)}</p>
            </CartItem>
          )
          : <H1>Cart empty!</H1>
        }
      </CartList>
      <hr style={{margin:'1em'}}/>
      <Flex justifyContent='space-between'>
        <p>Subtotal:</p>
        <p>
          ${subtotal}
        </p>
      </Flex>
      <FormButtons>
        <Button disabled={!cart.length} onClick={handleCheckout}>Checkout</Button>
      </FormButtons>
    </CartCard>
  )
}